import { requestKlaviyo, newsletterPayload } from './dome-klaviyo.js';

export class DomeNewsletterSignup extends HTMLElement {
  #controller;
  #submitting = false;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const form = this.querySelector('form');
    const email = this.querySelector('[type="email"]');
    const button = this.querySelector('button');
    const status = this.querySelector('[data-newsletter-status]');
    if (!form || !email || !button || !status) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.#submitting || !form.reportValidity()) return;
      const address = email.value.trim();
      if (!address) return;
      this.#submitting = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = this.dataset.saving;
      status.dataset.state = 'pending';
      try {
        await requestKlaviyo('subscriptions', newsletterPayload(address, this.dataset.source || 'Dome Peace website footer'));
        if (!this.isConnected) return;
        status.textContent = this.dataset.success;
        status.dataset.state = 'success';
        email.value = '';
        status.focus();
      } catch {
        if (!this.isConnected) return;
        status.textContent = this.dataset.error;
        status.dataset.state = 'error';
      } finally {
        this.#submitting = false;
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('dome-newsletter-signup')) customElements.define('dome-newsletter-signup', DomeNewsletterSignup);

